// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-menu-button__button[data-v-23c0e1a1]{all:unset;display:flex;align-items:center;height:100%;padding:0 15px;font-size:16px}.login-menu-button__button--logged-in[data-v-23c0e1a1]{color:var(--ion-color-primary)}", ""]);
// Exports
module.exports = exports;
